import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DiscoverLayout } from '#modules/finder/features/posts/components/Discover/DiscoverLayout';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/_discover'
)({
  component: LayoutComponent,
  ssr: false,
});

function LayoutComponent() {
  return (
    <DiscoverLayout>
      <Outlet />
    </DiscoverLayout>
  );
}
